module.exports = __webpack_public_path__ + "static/media/video.e7e28119.mp4";